// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3q5w6","noInteraction":"EventWrapper_noInteraction__3iprj","pointerPassthrough":"EventWrapper_pointerPassthrough__Pehjd"};